<template>
  <div class="form-document p-2 p-lg-5">
    <div>
      <div v-html="item.description"></div>
      <div class="text-center pt-5">
        <button
          v-if="hasCredits"
          class="btn btn-primary px-5"
          @click="dialog = true"
        >
          Enviar novo
        </button>
        <a
          v-else
          target="_blank"
          :href="item.url"
          class="btn btn-primary px-5 d-inline-flex align-items-center"
        >
          Comprar créditos
        </a>
      </div>
    </div>

    <b-modal v-model="dialog" hide-footer centered size="lg">
      <form @submit.prevent="submit">
        <form-group
          id="name"
          v-model="form.name"
          :errors="errors.name"
          placeholder="Seu nome"
          label="Qual o seu nome completo?"
          required
        />
        <form-group
          id="email"
          v-model="form.email"
          :errors="errors.email"
          type="email"
          placeholder="email@exemplo.com"
          label="Qual e-mail podemos usar para te enviar os documentos corrigidos?"
          required
        />
        <form-group
          id="whatsapp"
          v-model="form.whatsapp"
          :errors="errors.whatsapp"
          mask="(##) # ####-####"
          placeholder="(11) 12345-6789"
          label="Qual seu número de WhatsApp"
          required
        />
        <form-group
          id="documentType"
          v-model="form.documentType"
          :errors="errors.documentType"
          select
          :options="documentTypes"
          label="Qual documento está sendo enviado para correção?"
          placeholder="Selecione"
          required
        />
        <form-group
          id="link"
          v-model="form.link"
          :errors="errors.link"
          placeholder="Digite aqui"
          label="Tem algum link específico da oportunidade ou alguma informação importante para ajudar na revisão? Caso sim, insira aqui"
        />
        <form-group
          id="academicFormation"
          v-model="form.academicFormation"
          :errors="errors.academicFormation"
          placeholder="Selecione"
          label="Qual sua formação?"
          required
          select
          :options="formationTypes"
        />
        <form-group
          id="lessonWatched"
          v-model="form.lessonWatched"
          :errors="errors.lessonWatched"
          placeholder="Selecione"
          label="Você já assistiu as aulas sobre o documento que está sendo enviado?"
          required
          select
          :options="[
            { id: 'Sim', name: 'Sim' },
            { id: 'Não', name: 'Não' }
          ]"
        />
        <label>
          Faça o upload do documento que você está solicitando a correção.
        </label>
        <p class="text-small">
          Caso seu documento esteja num link editável, insira o link num arquivo
          Word e faça o upload deste arquivo aqui.
        </p>
        <file-input @pick="pickFile" />

        <div class="pt-5 text-center">
          <button class="btn btn-primary rounded-pill px-5">
            <loading :show="loading">
              Enviar
            </loading>
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import get from "lodash/get";

export default {
  props: {
    hasCredits: {
      type: Boolean,
      default: true
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false,
      file: null,
      documentTypes: [
        { id: "Personal Statement", name: "Personal Statement" },
        { id: "Statement of Purpose", name: "Statement of Purpose" },
        { id: "Supplemental Essays", name: "Supplemental Essays" },
        { id: "Personal Letter", name: "Personal Letter" },
        { id: "Cover Letter", name: "Cover Letter" },
        { id: "Motivational Letter", name: "Motivational Letter" },
        { id: "Resume / CV", name: "Resume / CV" },
        { id: "School Profile", name: "School Profile" },
        { id: "Outro", name: "Outro" }
      ],
      formationTypes: [
        { id: "Estou no ensino médio", name: "Estou no ensino médio" },
        {
          id: "Terminei o ensino médio mas ainda não entrei na faculdade",
          name: "Terminei o ensino médio mas ainda não entrei na faculdade"
        },
        { id: "Estou na faculdade", name: "Estou na faculdade" },
        { id: "Me formei da faculdade", name: "Me formei da faculdade" },
        {
          id: "Estou cursando algum tipo de pós graduação",
          name: "Estou cursando algum tipo de pós graduação"
        },
        { id: "Pós graduado", name: "Pós graduado" }
      ],
      ...formFields(
        [
          "name",
          "whatsapp",
          "email",
          "documentType",
          "link",
          "academicFormation",
          "lessonWatched"
        ],
        {
          ...this.$user.user
        }
      )
    };
  },
  methods: {
    submit() {
      if (!this.file) {
        this.$message.error("Selecione um documento para enviar");
        return;
      }

      this.loading = true;
      this.$store
        .dispatch("documents/upload", { file: this.file, form: this.form })
        .then(() => {
          this.$emit("success");
          this.dialog = false;
          this.file = null;
          this.$message.success("Arquivo enviado com sucesso!");
        })
        .catch(error => {
          const message = get(
            error.response,
            "message",
            "Erro! Por favor, tente novamente mais tarde."
          );
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
          this.$emit("success");
          //this.$router.push({ name: "documents" });
          this.$store.dispatch("user/get");
        });
    },
    pickFile(file) {
      this.file = file;
      // this.dialog = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.form-document {
  h5 {
    margin-bottom: 18px;
    font-weight: normal;
    color: rgba(255, 255, 255, 0.7);
  }

  .text-small {
    font-size: 14px;
  }
}
</style>
